import { Box, Typography } from '@mui/material';
import AnimatedSection from './AnimatedSection';

export default function SectionHeader({
  overline,
  title,
  subtitle,
  align = 'center',
  light = false,
  sx,
}) {
  return (
    <AnimatedSection>
      <Box sx={{ textAlign: align, mb: { xs: 5, md: 7 }, ...sx }}>
        {overline && (
          <div>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1.5,
                px: 2.5,
                py: 1,
                borderRadius: 12,
                background: light
                  ? 'linear-gradient(135deg, rgba(209, 188, 138, 0.18) 0%, rgba(209, 188, 138, 0.1) 100%)'
                  : 'linear-gradient(135deg, rgba(209, 188, 138, 0.15) 0%, rgba(209, 188, 138, 0.08) 100%)',
                border: `1px solid ${light ? 'rgba(209, 188, 138, 0.35)' : 'rgba(209, 188, 138, 0.25)'}`,
                mb: 3,
                boxShadow: '0 4px 12px rgba(209, 188, 138, 0.12)',
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #D1BC8A 0%, #B8A06E 100%)',
                  boxShadow: '0 0 12px rgba(209, 188, 138, 0.8)',
                }}
              />
              <Typography
                variant="subtitle2"
                sx={{
                  color: light ? '#E8DEC3' : 'primary.main',
                  fontWeight: 700,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                }}
              >
                {overline}
              </Typography>
            </Box>
          </div>
        )}
        <div>
          <Typography
            variant="h2"
            sx={{
              color: light ? 'white' : 'text.primary',
              mb: subtitle ? 3 : 0,
              background: light
                ? 'linear-gradient(135deg, #FFFFFF 0%, rgba(255,255,255,0.88) 100%)'
                : 'none',
              WebkitBackgroundClip: light ? 'text' : 'initial',
              WebkitTextFillColor: light ? 'transparent' : 'initial',
              backgroundClip: light ? 'text' : 'initial',
              position: 'relative',
              '&::after': !light && align === 'center' ? {
                content: '""',
                position: 'absolute',
                bottom: -16,
                left: '50%',
                transform: 'translateX(-50%)',
                width: 60,
                height: 4,
                borderRadius: 2,
                background: 'linear-gradient(90deg, #D1BC8A 0%, #E8DEC3 50%, #D1BC8A 100%)',
                boxShadow: '0 2px 8px rgba(209, 188, 138, 0.4)',
              } : {},
            }}
          >
            {title}
          </Typography>
        </div>
        {subtitle && (
          <div>
            <Typography
              variant="subtitle1"
              sx={{
                color: light ? 'rgba(255,255,255,0.85)' : 'text.secondary',
                maxWidth: 680,
                mx: align === 'center' ? 'auto' : 0,
                fontSize: '1.08rem',
                lineHeight: 1.75,
              }}
            >
              {subtitle}
            </Typography>
          </div>
        )}
      </Box>
    </AnimatedSection>
  );
}
